let increment= 0;

export default (event,data) => {
  let event_data = { event };
  let inc = 0;
  window.dataLayer = window.dataLayer || [];
  switch(event){
    case "close_ebook_popup":
      event_data.interaction = increment + 1;
      increment++;
      break;
    case "search_header_movie":
      event_data.movie_name = data.movie_name;
      event_data.interaction = increment + 1;
      increment++;
      break;
    case "search_header_distributor":
      event_data.distributor = data.distributor;
      event_data.interaction = increment + 1;
      increment++;
      break;
    case "search_header_country":
      event_data.country = data.country;
      event_data.interaction = increment + 1;
      increment++;
      break;
    case "search_header_date":
      event_data.date_from = data.from;
      event_data.date_to = data.to;
      event_data.interaction = increment + 1;
      increment++;
      break;
    case "open_movie":
      event_data.movie_name = data.movie_name;
      event_data.interaction = increment + 1;
      increment++;
      break;
    case "change_eurofilm_page":
      event_data.page = data.page;
      event_data.interaction = increment + 1;
      increment++;
      break;
    case "hubspot_form_submitted":
      event_data.interaction = increment +1;
      increment++;
      break;
  }
  window.dataLayer.push(event_data);
}




// WEBPACK FOOTER //
// ./src/lib/tracking.js